/*
 * @Description: 客户管理
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Tab } from '@alifd/next';
import style from './index.module.scss';
import utils from '@/common/utils';
import CrowdManage from './components/CrowdManage/crowdManage'; // 人群管理
import BlackList from './components/UserBlackList'; // 黑名单管理
import { event, store } from '@ice/stark-data';

const TabItem = Tab.Item;

/** 客户管理页面 */
const orderSelection = (): JSX.Element => {
  const [currentTabKey, setCurrentTabKey] = useState('crowdManage');// 当前tab

  // 21年8月，应对抖音官方调整，暂时下线功能
  // const tabsList = { 'crowdManage': '人群管理', 'userBlackList': '黑名单管理' }; //tabs字典
  const tabsList = { crowdManage: '人群管理' }; // tabs字典

  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();

    // 从父组件中获取已保存的currentTabKey，如果该可以为本页面tabs的key,则直接赋值，否则使用原有默认值
    const setPageTabKey = store.get('currentTab');

    // 设置当前tab 高亮
    changeTabs(tabsList[setPageTabKey] ? setPageTabKey : currentTabKey);
  };
  /**  获取数据 */
  const getPageData = (): void => {
    // 订单状态字典
  };

  /**
   * tabs 改变时触发
   * @param tabKey string
   */
  const changeTabs = (tabKey: string): void => {
    setCurrentTabKey(tabKey);

    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '客户管理', // 一级页面名称
      url: '/web/CustomerManagement', // 一级页面url
      children: {
        name: tabsList[tabKey], // 二级页面名称
        url: '/web/CustomerManagement', // 二级页面url
      },
    });

    // 将当前key 传入父组件
    event.emit('currentTab', tabKey);
  };

  return (
    <>

      <div className="setTabsStyle">
        {/* 页面tabs shape="wrapped" */}
        <Tab
          animation
          navClassName={style.tabsStyle}
          onChange={changeTabs}
          activeKey={currentTabKey}
          className="tabStyle_hjy"
        >
          {Object.keys(tabsList).map((key) => {
            return (<TabItem title={tabsList[key]} key={key} />);
          })}
        </Tab>


        <div className={style.mainBox}>

          {
            currentTabKey === 'crowdManage' && <CrowdManage />
          }

          {
            currentTabKey === 'userBlackList' && <BlackList />

          }
        </div>

      </div>
    </>
  );
};


export default orderSelection;
